@if (displayThisLink) {
  <app-button-atom
    size="L"
    [label]="text() ?? ''"
    type="primary"
    [full]="true"
    (click)="click()"
    [iconUrl]="icon()?.url ?? ''"
  >
  </app-button-atom>
}
